const activeClass = 'active';
const bodyClass = 'nModal_Opened';
const openedModals = [];

$(document).on('click', '.openModal', e => {
  e.preventDefault();
  const modalId = $(e.currentTarget).data('modalid');
  if (!modalId) {
    return;
  }

  openedModals.push(modalId);

  $(`#${modalId}`).addClass(activeClass);
  $('body').addClass(bodyClass);
});

$(document).on('click', '.closeNModal', () => {
  if (openedModals.length > 0) {
    const index = openedModals.length - 1;
    const modalId = openedModals[index];
    $(`#${modalId}`).removeClass(activeClass);
    openedModals.splice(index, 1);
  }

  if (openedModals.length === 0) {
    setTimeout(() => {
      $('body').removeClass(bodyClass);
    }, 150);
  }
});
